module.exports = __webpack_public_path__ + "img/logo_5.f5748f31.png";